export * from './src/sortablejs.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-sortablejs/dist/index.js
// module id = 868
// module chunks = 10